<template>
  <div style="min-height: 100%;overflow-y: auto;">
    <el-row class="main">
      <div class="card-box">
        <!-- 右边卡片 -->
        <div class="card-rb">
          <div class="card-4">
            <el-card>
              <div>
                <el-form :inline="true"
                        class="demo-form-inline"
                        size="mini"
                        :model="searchlist">
                  <el-form-item label="活动主题:"
                                prop="title">
                    <el-input v-model="searchlist.activityTheme"
                              placeholder="请输入活动主题"></el-input>
                  </el-form-item>
                  <el-form-item label="活动状态:"
                                prop="title">
                    <el-select v-model="searchlist.activityStatus"
                              placeholder="请选择">
                      <el-option v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="活动时间:"
                                prop="title">
                    <el-date-picker v-model="activityTimeses"
                                    type="datetimerange"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"></el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary"
                              @click="search">查询</el-button>
                  </el-form-item>
                  <el-form-item>
                    <el-button type="info"
                              @click="searchlistReset">重置</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div class="three">
                <el-button type="primary"
                           size="mini"
                           @click="addInfo">新增</el-button>
              </div>
              <!-- 表格盒子 -->
              <div class="table_card">
                <el-table ref="singleTable"
                          :data="tableData"
                          highlight-current-row
                          style="width: 100%;margin-top: 16px"
                          border>
                  <el-table-column align="center"
                                   label="序号"
                                   type="index"
                                   width="50"></el-table-column>
                  <el-table-column align="center"
                                   prop="activityTheme"
                                   label="服务主题"
                                   :show-overflow-tooltip="true"></el-table-column>
                  <el-table-column align="center"
                                   prop="organizer"
                                   label="主办单位"
                                   :show-overflow-tooltip="true"></el-table-column>
                  <el-table-column align="center"
                                   prop="contacts"
                                   label="联系人"
                                   :show-overflow-tooltip="true"></el-table-column>
                  <el-table-column align="center"
                                   prop="activityTimes"
                                   label="活动时间"
                                   :show-overflow-tooltip="true"
                                   width="350">
                    <template scope="scope">
                      {{scope.row.startActivityTime}} - {{scope.row.endActivityTime}}
                    </template>
                  </el-table-column>
                  <el-table-column align="center"
                                   label="上限人数"
                                   prop="upperLimit"
                                   :show-overflow-tooltip="true"></el-table-column>
                  <!-- <el-table-column align="center" label="报名人数" prop="applicantsNum" :show-overflow-tooltip="true"></el-table-column> -->
                  <el-table-column align="center"
                                   label="截止报名时间"
                                   prop="signUpTimes"
                                   width="150"
                                   :show-overflow-tooltip="true">
                    <template scope="scope">
                      {{ scope.row.signUpTimes }}
                    </template>
                  </el-table-column>
                  <el-table-column align="center"
                                   label="活动状态"
                                   prop="activityStatus"
                                   :show-overflow-tooltip="true">
                    <template scope="scope">
                      <span v-if="scope.row.activityStatus == '0'">报名中</span>
                      <span v-if="scope.row.activityStatus == '1'">报名已结束</span>
                      <span v-if="scope.row.activityStatus == '2'">报名已终止</span>
                      <span v-if="scope.row.activityStatus == '3'">活动未开始</span>
                      <span v-if="scope.row.activityStatus == '4'">活动中</span>
                      <span v-if="scope.row.activityStatus == '5'">活动已结束</span>
                      <span v-if="scope.row.activityStatus == '6'">活动归档</span>
                      <span v-if="scope.row.activityStatus == '7'">活动已发布</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center"
                                   label="审批状态"
                                   prop="approvalStatus"
                                   :show-overflow-tooltip="true">
                    <template scope="scope">
                      <span v-if="scope.row.approvalStatus == '0'">待审批</span>
                      <span v-if="scope.row.approvalStatus == '1'">审批已通过</span>
                      <span v-if="scope.row.approvalStatus == '2'">审批不通过</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="operation"
                                   label="操作"
                                   align="center"
                                   width="250px"
                                   fixed="right">
                    <template scope="scope">
                      <el-tooltip class="item"
                                  effect="light"
                                  content="查看"
                                  placement="top-start"
                                  v-if="scope.row.activityStatus != 7">
                        <button style="color:skyblue"
                                class="iconfont icon-chakan tabBtn"
                                @click="lookDialog(scope.row.id)"></button>
                      </el-tooltip>
                      <el-tooltip class="item"
                                  effect="light"
                                  content="查看"
                                  placement="top-start"
                                  v-if="scope.row.activityStatus == 7">
                        <button style="color:skyblue"
                                class="iconfont icon-chakan tabBtn"
                                @click="lookAllDialog(scope.row.id)"></button>
                      </el-tooltip>
                      <!-- v-if="scope.row.editButtonFlag == '1'" -->
                      <el-tooltip class="item"
                                  effect="light"
                                  content="修改"
                                  placement="top-start">
                        <button class="iconfont icon-bianji3 tabBtn"
                                style="color: #2e99cf;"
                                v-if="scope.row.editButtonFlag == '1'"
                                @click="editDialog(scope.row.id)"></button>
                      </el-tooltip>
                      <el-tooltip class="item"
                                  effect="light"
                                  content="审核"
                                  placement="top-start">
                        <button style="color: #ff04ed;"
                                class="iconfont icon-shenhe tabBtn"
                                v-if="scope.row.auditButtonFlag == '1'"
                                @click="shenheDialog(scope.row.id)"></button>
                      </el-tooltip>
                      <el-tooltip class="item"
                                  effect="light"
                                  content="审核人员"
                                  placement="top-start">
                        <button class="iconfont el-icon-user-solid tabBtn"
                                style="color: #e400ff;"
                                v-if="scope.row.auditPersonButtonFlag == '1'"
                                @click="shenhePerson(scope.row.id)"></button>
                      </el-tooltip>
                      <el-tooltip class="item"
                                  effect="light"
                                  content="终止"
                                  placement="top-start">
                        <button class="iconfont icon-xuanxiangkuangqueding tabBtn"
                                v-if="scope.row.stopFlag == '1'"
                                @click="endingSave(scope.row.id)"></button>
                      </el-tooltip>
                      <el-tooltip class="item"
                                  effect="light"
                                  content="打印签到列表"
                                  placement="top-start">
                        <button style="color: #dd3020"
                                class="iconfont icon-dayin tabBtn"
                                v-if="scope.row.printButtonFlag == '1'"
                                @click="singForm(scope.row.id)"></button>
                      </el-tooltip>
                      <el-tooltip class="item"
                                  effect="light"
                                  content="活动总结"
                                  placement="top-start">
                        <button style="color: #7c48f4"
                                class="iconfont icon-zongjie tabBtn"
                                v-if="scope.row.activitySummaryButtonFlag == '1'"
                                @click="activeSummary(scope.row.id)"></button>
                      </el-tooltip>
                      <el-tooltip class="item"
                                  effect="light"
                                  content="活动发布"
                                  placement="top-start">
                        <button style="color: #ff04ed"
                                class="iconfont icon-fabu tabBtn"
                                v-if="scope.row.activityPublishButtonFlag == '1'"
                                @click="activeFB(scope.row.id)"></button>
                      </el-tooltip>
                      <!-- <el-tooltip class="item"
                                  effect="light"
                                  content="活动发布"
                                  placement="top-start">
                        <button style=""
                                class="iconfont icon-fabu2 tabBtn"
                                v-if="scope.row.activityPublishButtonFlag == '1'"
                                @click="activeFB(scope.row.id)"></button>
                      </el-tooltip> -->
                      <el-tooltip class="item"
                                  effect="light"
                                  content="删除"
                                  placement="top-start">
                        <button style="color:red"
                                class="iconfont icon-icon7 tabBtn"
                                @click="deleteDialog(scope.row.id)"></button>
                      </el-tooltip>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination style="margin:20px 0;"
                               @current-change="handleCurrentChange"
                               :current-page="pageConfig.pageNo"
                               :page-size="10"
                               layout="total, prev, pager, next, jumper"
                               :total="pageConfig.total"></el-pagination>
              </div>
            </el-card>
          </div>
        </div> 
      </div>
    </el-row>
    <el-dialog :title='lookTitle' :visible.sync='showcheck' width='955px' @close="closeProject">
      <LookProject ref='LookProject' :rowid='rowid' :readonlys='readonlyInfo' @close='closeProject'></LookProject>
    </el-dialog>
    <el-dialog title='查看' :visible.sync='lookActivityFlowTitle' width='955px' @close="closelookActivity">
      <ActivityFlowLook ref='ActivityFlowLook' :rowid='rowid' :readonlys='readonlyInfo' @close='closelookActivity'></ActivityFlowLook>
    </el-dialog>
    <el-dialog title='审核人员' :visible.sync='showcheckApproval' width='955px' @close="closeApproval">
      <ActivityFlowApproval ref='ActivityFlowApproval' :rowid='rowid' @close='closeApproval'></ActivityFlowApproval>
    </el-dialog>
    <el-dialog title='打印签到表' :visible.sync='showcheckForm' width='955px' @close="closeForm">
      <ActivityFlowForm ref='ActivityFlowForm' :rowid='rowid' @close='closeForm'></ActivityFlowForm>
    </el-dialog>
    <el-dialog title='活动总结' :visible.sync='showcheckSummary' width='955px' @close="closeSummary">
      <ActivityFlowSummary ref='ActivityFlowSummary' :rowid='rowid' @close='closeSummary'></ActivityFlowSummary>
    </el-dialog>
    <el-dialog title='活动发布' :visible.sync='showcheckfabu' width='955px' @close="closefabu">
      <ActivityFlowfabu ref='ActivityFlowfabu' :rowid='rowid' @close='closefabu'></ActivityFlowfabu>
    </el-dialog>
  </div>
</template>
<script>
import { post } from "@/api/requrestHttp.js";
import { sskldApi } from "@/api/http";
import LookProject from "@/views/governmentAffairschildren/gridding/lookproject.vue";
import ActivityFlowLook from "@/views/governmentAffairschildren/gridding/liucheng/activityFlowLook.vue";
import ActivityFlowApproval from "@/views/governmentAffairschildren/gridding/liucheng/activityFlowApproval.vue";
import ActivityFlowForm from "@/views/governmentAffairschildren/gridding/liucheng/activityFlowForm.vue";
import ActivityFlowSummary from "@/views/governmentAffairschildren/gridding/liucheng/activityFlowSummary.vue";
import ActivityFlowfabu from "@/views/governmentAffairschildren/gridding/liucheng/activityFlowfabu.vue";
import { tabdata } from "@/mixins/tabledataMix.js";
export default {
  components: { LookProject, ActivityFlowLook, ActivityFlowApproval, ActivityFlowForm, ActivityFlowSummary,ActivityFlowfabu },
  mixins: [tabdata],
  data () {
    return {
      rowid: '',
      lookTitle: '查看',
      readonlyInfo: false,
      showcheck: false,
      lookActivityFlowTitle: false,
      showcheckApproval: false,
      showcheckForm: false,
      showcheckSummary: false,
      showcheckfabu:false,
      sqrTitle: '查看',
      isaudit: false,
      outerVisible: false,
      ruleForm: {},
      searchlist: {},
      platformcheckList: [],
      photoDialogVisible: false,
      dialogTableVisible: false,
      checked: true,
      personDialogTableVisible: false,
      shenhedialogVisibleTwo: false,
      lookDialogVisible: false,
      editDialogVisible: false,
      addDialogVisible: false,
      daYinQianDaoShow: false,
      dayinData: [],
      rules: {
        // name: [{ required: true, message: "请输入姓名", trigger: "blur" , trigger: "blur",}],
        // sex: [{ required: true, message: "请选择性别", trigger: "blur" , trigger: "blur",}], 
        phone:
          [{ required: true, message: '请输入手机号码', trigger: 'blur' },
          {
            validator: function (rule, value, callback) {
              if (/^1[34578]\d{9}$/.test(value) == false) {
                callback(new Error("请输入正确的手机号"));
              } else {
                callback();
              }
            }, trigger: 'blur'
          }],
        // idCode: 
        //   [{required: true,message: '请输入身份证号',trigger: 'blur'},
        //     { pattern:/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '你的身份证格式不正确' }],
        // photoPath: [{ required: false, message: "请上传照片", trigger: "blur" }],
        // communityPerson: [{ required: true, message: "请选择是否是社区工作人员", trigger: "change", }],
        // status: [{ required: true, message: "请选择启动状态", trigger: "change", }],
      },
      options: [
        { value: "0", label: "报名中", },
        { value: "1", label: "报名已结束", },
        { value: "2", label: "报名已终止", },
        { value: "3", label: "活动未开始", },
        { value: "4", label: "活动中", },
        { value: "5", label: "活动已结束", }, 
        { value: "6", label: "活动归档", },
        { value: "7", label: "活动已发布", }, 
      ],
      value: "",
      input: "",
      addform: {
        activityTheme: "",
        organizer: "",
        contacts: "",
        startActivityTime: "",
        endActivityTime: "",
        upperLimit: "",
        publishPlatform: "",
      },
      activityTimes: [],
      lookform: {},
      editform: {},
      shenheform: {},
      value1: "",
      value2: "",
      tableData: [],
      radio: "",
      imageUrl: "",
      form: {},
      activityTimeses: [],
      formLabelWidth: "130px",
      gridData: [],
      shenheid: "",
      pageConfig: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      multipleSelection: [],
      approvedCount: "",
      notReviewedCount: "",
      signUpCount: "",
      activityTheme: "",
      activityTimes1: "",
      upperLimit: "",
      shId: '',
    };
  },
  created () {
    this.initTableDataUrl("/admin/serviceItems/info/listServiceItems");
    this.changeTime()
    this.search();
    
  },
  mounted(){
    this.search()
  },
  methods: {
    closeProject () {
      this.showcheck = false;
      this.search();
    },
    closelookActivity() {
      this.lookActivityFlowTitle= false;
      this.search();
    },
    closeApproval () {
      this.showcheckApproval = false;
      this.search();
    },
    closeForm () {
      this.showcheckForm = false;
      this.search();
    },
    closeSummary () {
      this.showcheckSummary = false;
      this.search();
    },
    closefabu(){
      this.showcheckfabu = false;
      this.search();
    },
    loogSub (id, type) {
      this.ruleForm = {}
      this.outerVisible = true;
      if (type == 'audit') {
        this.sqrTitle = '审核'
        this.isaudit = true
        this.shId = id
      }
      console.log(this.isaudit);
      post("/admin/serviceItemsPerson/info/getServiceItemsPerson", {
        id: id,
      }).then((res) => {
        console.log(res.content);
        this.ruleForm = res.content;

      });
    },
    submitForm () {
      post("/admin/serviceItemsPerson/info/updateServiceItemsPerson", {
        id: this.shId,
        approvalStatus: this.ruleForm.approvalStatus,
        approvalOpinion: this.ruleForm.approvalOpinion,
      }).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: '审核成功'
          });
          this.outerVisible = false
        }

      });
    },
    resetForm (formName) {
      this.ruleForm = {};
      this.outerVisible = false
    },
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`);
      this.pageConfig.pageNo = val;
      this.search();
    },
    // 点击新增
    addInfo () {
      this.lookTitle = '新增';
      this.showcheck = true;
      this.$nextTick(() => {
        this.$refs.LookProject.readonly = false;
        this.$refs.LookProject.addsend = true;
        this.$refs.LookProject.auditsendan = false;
        this.$refs.LookProject.editsend = false;
        this.$refs.LookProject.getData();
        // this.$refs.LookProject.getDetail();
      })
    },
    // 点击查看
    lookDialog (id) {
      this.showcheck = true;
      this.rowid = id;
      this.lookTitle = '查看';
      setTimeout(() => {
        this.$nextTick(() => {
          this.$refs.LookProject.id = this.rowid;
          this.$refs.LookProject.addsend = false;
          this.$refs.LookProject.auditsendan = false;
          this.$refs.LookProject.editsend = false;
          this.$refs.LookProject.readonly = true;
          this.$refs.LookProject.getData();
          this.$refs.LookProject.getDetail();
        })
      }, 100)
    },
    lookAllDialog(id) {
      this.lookActivityFlowTitle = true;
      this.rowid = id;
      setTimeout(() => {
        this.$nextTick(() => {
          this.$refs.ActivityFlowLook.issueCJ();
        })
      }, 100) 
    },
    // 点击修改
    editDialog (id) {
      this.lookTitle = '修改';
      this.showcheck = true;
      this.rowid = id;
      setTimeout(() => {
        this.$nextTick(() => {
          this.$refs.LookProject.addsend = false;
          this.$refs.LookProject.auditsendan = false;
          this.$refs.LookProject.editsend = true;
          this.$refs.LookProject.id = this.rowid;
          this.$refs.LookProject.readonly = false;
          this.$refs.LookProject.getData();
          this.$refs.LookProject.getDetail();
        })
      }, 100)
    },
    shenheDialog (id) {
      console.log(id);
      this.activityTimes = [];
      this.shenhedialogVisibleTwo = true;
      post("/admin/serviceItems/info/getServiceItems", {
        id: id,
      }).then((res) => {
        console.log(res);
        this.shenheform = res.content;
        if (res.content.startActivityTime !== null && res.content.startActivityTime !== null) {
          this.activityTimes.push(res.content.startActivityTime);
          this.activityTimes.push(res.content.endActivityTime);
        }
        console.log(this.activityTimes);
        this.platformcheckList = res.content.publishPlatform.split(",");
      });
    },
    // 点击审核人员
    shenhePerson (id) {
      this.showcheckApproval = true;
      this.rowid = id;
      setTimeout(() => {
        this.$nextTick(() => {
          this.$refs.ActivityFlowApproval.id = this.rowid;
          this.$refs.ActivityFlowApproval.jbinfo();
        })
      }, 100)
    },
    // 点击打印签到表
    singForm (id) {
      this.showcheckForm = true;
      this.rowid = id;
      console.log(this.rowid);
      setTimeout(() => {
        this.$nextTick(() => {
          this.$refs.ActivityFlowForm.blbanli();
        })
      }, 100)
    },
    // 活动总结
    activeSummary (id) {
      this.showcheckSummary = true;
      this.rowid = id;
      setTimeout(() => {
        this.$nextTick(() => {
          this.$refs.ActivityFlowSummary.blresult();
        })
      }, 100)
    },
    // 活动发布
    activeFB (id) {
      this.showcheckfabu = true;
      this.rowid = id;
      setTimeout(() => {
        this.$nextTick(() => {
          this.$refs.ActivityFlowfabu.id = this.rowid;
          // this.$refs.ActivityFlowfabu.addsend = false;
          // this.$refs.ActivityFlowfabu.auditsendan = false;
          // this.$refs.ActivityFlowfabu.editsend = false;
          this.$refs.ActivityFlowfabu.readonly = true;
          this.$refs.ActivityFlowfabu.getData();
          this.$refs.ActivityFlowfabu.getDetail()
          this.$refs.ActivityFlowfabu.mapInit("container")
        })
      }, 100)
      
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection)
    },
    deleteDialog (id) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '删除成功'
        });
        post("/admin/serviceItems/info/deleteServiceItems", {
          id: id,
        }).then((res) => {
          this.search();
        });

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    addformClick () { 
      this.addSave(); 
    }, 
    // 终止服务项目
    endingSave (id) {
      this.$confirm('此操作将终止该项服务, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        post("/admin/serviceItems/info/updateServiceItems", {
          id: id,
          activityStatus: '3',
        }).then((res) => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "已终止该项服务"
            });
            this.search();
          }
        });
      }).catch(() => { });
    },
    search() {
      this.searchlist.startActivityTime = this.activityTimeses[0];
      this.searchlist.endActivityTime = this.activityTimeses[1];
      post("/admin/serviceItems/info/listServiceItems", {
        ...this.searchlist,
        pageNo: this.pageConfig.pageNo,
        pageSize: this.pageConfig.pageSize,
      }).then((res) => {
        console.log(res); 
        this.tableData = res.content.list;
        this.tableData.forEach(item => {
          item.signUpTimes = item.signUpTimes.substring(0, 16);
          item.startActivityTime = item.startActivityTime.substring(0, 16);
          item.endActivityTime = item.endActivityTime.substring(0, 16)
        })
      });
    },
    // 重置
    searchlistReset () {
      this.searchlist = {};
      this.activityTimeses = [];
      this.search();
    }, 
    shenheSave () {
      post("/admin/serviceItems/info/updateServiceItems", {
        id: this.shenheid,
        approvalStatus: this.shenheform.approvalStatus,
        approvalOpinion: this.shenheform.approvalOpinion,
      }).then((res) => {
        this.shenhedialogVisibleTwo = false;
        this.search();
      });
    },
    handleAvatarSuccess (file, fileList) {
      console.log(file.content);
      this.addform.photo = file.content;
      this.lookform.photo = file.content;
      this.editform.photo = file.content;
      this.shenheform.photo = file.content;
      console.log(this.addform.photo);
      console.log(fileList);
    },
    async daochu () {
      let data = {

      };
      let res = await sskldApi.exportServiceItemsPerson(data);
      const blob = new Blob([res], { type: "application/vnd.ms-excel" });
      const fileName = "服务项目报名人员.xls";
      const linkNode = document.createElement("a");
      linkNode.download = fileName; //a标签的download属性规定下载文件的名称
      linkNode.style.display = "none";
      linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
      document.body.appendChild(linkNode);
      linkNode.click(); //模拟在按钮上的一次鼠标单击
      URL.revokeObjectURL(linkNode.href); // 释放URL 对象
      document.body.removeChild(linkNode);
    },
    changeTime () {
      this.search();
      console.log('table==============', this.tableData)
    }
  },


};
</script>

<style lang="less" scoped>
.dialog-footer {
  display: flex;
  justify-content: center;
}
.main {
  width: 100%;
  height: 100%;
  position: relative;

  .mapdiv {
    height: 100%;
    width: 100%;
    overflow: hidden;
  }

  .pic {
    height: 50px;
    width: 100%;
    position: absolute;
    bottom: 50px;
    left: 0;
    z-index: 9999;
    background-image: url("../../../assets/images/zhzx.png");
    background-size: 100% 100%;

    .pic-nav {
      width: 50%;
      height: 100%;
      margin: 0 auto;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
    }

    .nav-cli {
      cursor: pointer;
      width: 30%;
      height: 80%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: #fff;
      font-size: 18px;
    }
  }

  .m-lr1 {
    display: flex;
    align-items: center;
    z-index: 999;
    position: absolute;
    top: 0;
    left: 0;
    height: calc(100% - 88px);
    width: 20vw;
    background-color: rgba(252, 250, 250, 0.1);

    .m-cli {
      width: 100%;
      height: 50%;
    }
  }

  .m-lr2 {
    z-index: 999;
    display: flex;
    align-items: center;
    position: absolute;
    right: 0;
    top: 0;
    height: calc(100% - 88px);
    width: 20vw;
    background-color: rgba(252, 250, 250, 0.1);

    .m-cli {
      width: 100%;
      height: 50%;
    }
  }
}

// 左上echart盒子
#l-t-chartbox,
#l-b-chartbox,
#r-t-chartbox,
#r-b-chartbox {
  // margin-top: 10%;
  // padding-top: 8%;
  width: 100%;
  height: 100%;
  // background-color: rgb(172, 149, 149);
}

.chart_title {
  width: 100%;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
}

// 重置按钮和全屏按钮
.mapbox {
  position: relative;
  height: 100%;
  width: 100%;

  .quanping {
    color: #fff;
    font-size: 30px;
    position: absolute;
    right: 20px;
    top: 40px;
    font-weight: 600;
    z-index: 4;
  }

  .chongzhi {
    color: #fff;
    font-size: 32px;
    position: absolute;
    right: 20px;
    top: 90px;
    font-weight: 500;
    z-index: 4;
  }

  .quxiao {
    color: #fff;
    font-size: 30px;
    position: absolute;
    right: 20px;
    top: 140px;
    font-weight: 400;
    z-index: 4;
  }
}

.mapboxactive {
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
}

.zoomInIcon {
  width: 31px;
  height: 31px;
}
/deep/ .tabBtn {
  font-size: 18px;
}
</style> 
